import BaseIconSvg from '@/components/bases/BaseIconSvg';
import EmrFormItem from '@/screens/CreateEmr/EmrInput/EmrFormItem';
import { IEmrInputProps } from '@/screens/CreateEmr/EmrInput/EmrInput';
import FileServices from '@/services/files';
import quickModal from '@/utils/quickModal';
import { Upload } from 'antd';
import { UploadProps } from 'antd/lib';
import * as React from 'react';
import _ from 'lodash';
import { RcFile } from 'antd/es/upload';
import utils from '@/utils';

export interface IEmrFileProps
  extends Pick<IEmrInputProps, 'name' | 'field' | 'labelProps'>,
    Omit<UploadProps, 'name'> {}

const EmrFile: React.FC<IEmrFileProps> = ({ disabled, name, field, labelProps = {}, ...props }) => {
  const [help, setHelp] = React.useState<string>('');
  //   const [fileListState, setFileListState] = React.useState<UploadFile<any>[]>([]);
  //   const ref = React.useRef<any>(null);
  //   React.useEffect(() => {
  //     const value = ref.current?.upload?.props?.value?.fileList
  //       ? ref.current?.upload?.props?.value?.fileList
  //       : ref.current?.upload?.props?.value?.split(',').map((url: string, i: number) => ({
  //           uid: String(i),
  //           name: url,
  //           status: 'done',
  //           url: url,
  //         }));
  //     setFileListState(value);
  //   }, []);

  //   const validator = field?.extra.validator;
  //   const debounceHandler = React.useMemo(
  //     () =>
  //       _.debounce(
  //         (values: string) =>
  //           quickModal.infoAsync({
  //             content: values,
  //           }),
  //         500,
  //       ),
  //     [],
  //   );

  return (
    <EmrFormItem
      field={field}
      name={name}
      rules={[{ required: !!field?.required }]}
      getValueFromEvent={({ fileList }) => {
        const result = fileList
          ?.map((f: any) => f.url)
          .filter(Boolean)
          .join(',');
        if (result) return result;
      }}
      {...labelProps}
      help={help}
    >
      <WrapUpload field={field} disabled={disabled} setHelp={setHelp} />
    </EmrFormItem>
  );
};
export default EmrFile;

const WrapUpload = ({
  field,
  disabled,
  value,
  setHelp,
  ...props
}: {
  field?: IFieldConfig;
  disabled?: boolean;
  setHelp: Function;
  value?: string;
}) => {
  const validator = field?.extra.validator;

  React.useEffect(() => {
    setHelp((value as string)?.split(',')?.length >= validator?.max?.[0] ? validator?.max?.[1] : '');
  }, [value, setHelp, validator?.max]);
  const debounceHandler = React.useMemo(
    () =>
      _.debounce(
        (values: string) =>
          quickModal.infoAsync({
            content: values,
          }),
        500,
      ),
    [],
  );
  return (
    <Upload
      accept={validator?.accept?.[0]}
      className={disabled ? '[&_.ant-upload-disabled]:hidden' : ''}
      disabled={disabled}
      defaultFileList={utils.parseLinks(value).map((o, i: number) => ({
        uid: String(i),
        name: o.fullName,
        status: 'done',
        url: o.url,
      }))}
      listType="picture"
      multiple
      maxCount={validator?.max?.[0]}
      onPreview={(file) => {
        const url = file?.url?.toLocaleLowerCase().includes('.dcm')
          ? `https://dicom-viewer.pta.com.vn/?input=${file?.url}`
          : file?.url;

        window.open(url);
      }}
      beforeUpload={async function (file: RcFile, fileList: RcFile[]) {
        if (validator?.max?.[0]) {
          if (fileList?.length > validator?.max?.[0]) {
            debounceHandler(validator?.max?.[1]);
          }
        }
        return true;
      }}
      customRequest={async (options: any) => {
        const { onSuccess, onError, file } = options;

        const listFileAccept = validator?.accept?.[0]?.split(',');
        if (listFileAccept?.length) {
          const extend = '.' + file?.name?.split('.')?.pop();

          if (!listFileAccept.includes(extend.toLowerCase())) {
            debounceHandler(validator?.accept[1]);
            return onError(validator?.accept[1]);
          }
        }

        if (validator?.maxSize?.[0] && file.size > validator?.maxSize?.[0] * 1048576) {
          quickModal.infoAsync({
            content: validator?.maxSize?.[1],
          });

          return onError(validator?.maxSize?.[1]);
        }

        try {
          const res = await FileServices.post({ key: 'phr:upload', file: file });
          if (!res) {
            onError('Upload lỗi');
          } else if (res?.error) {
            onError(res.error.message);
          } else {
            file.url = res?.data?.url;
            file.response = res?.data?.url;
            onSuccess(res?.data?.url, file);
          }
        } catch (error: any) {
          onError(error);
        }
      }}
      onRemove={async () => {
        return await quickModal.confirm({ content: 'Bạn có chắc muốn xóa ' });
      }}
      {...props}
    >
      <div className={`cursor-pointer border p-2 rounded-lg border-dashed ${disabled ? 'hidden' : ''}`}>
        <div className="flex justify-center">
          <BaseIconSvg src="/icons/Regular/Upload - icon.svg" />
        </div>
        Tải file
      </div>
    </Upload>
  );
};
